import React from 'react';
import { NavLink } from 'react-router-dom';
import { WorksheetStatus } from '../../Worksheets/Core/WorksheetStatus';
import './SearchNav.scss';

const SearchNav = ({ heading, links, placeholder }) => (
  <nav className="SearchNav">
    {heading && <h1 className="SearchNav-Heading">{heading}</h1>}
    {(!links || !links.length) && placeholder && <div className="SearchNav-Placeholder">{placeholder}</div>}
    {links &&
      links.map((l, i) => (
        <React.Fragment key={i}>
          {l.heading && (
            <h1 className="SearchNav-GroupHeading">
              {l.heading.tokens.map((t, j) => (
                <span key={i + '-' + j} className={t.highlight ? 'SearchNav-highlight' : ''}>
                  {t.text}
                </span>
              ))}
              {l.subHeading && (
                <span key={i} className="SearchNav-SubHeading">
                  {l.subHeading}
                </span>
              )}
            </h1>
          )}
          <NavLink to={l.uri} className="SearchNav-Item">
            <div className="SearchNav-Icon">
              <WorksheetStatus status={l.status} disablePopup />
            </div>
            <div className="SearchNav-Text">{l.text}</div>
          </NavLink>
        </React.Fragment>
      ))}
  </nav>
);

export default SearchNav;
